import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'shared/components/ui/icon';
import { PremiumUsp, premiumUsps } from 'shared/constants/premium-usps';

import * as Styled from './feature-list.style';

export type FeatureListProps = {
  usps?: PremiumUsp[];
};

export const FeatureList: React.FC<FeatureListProps> = ({
  usps = premiumUsps,
}) => {
  const { t } = useTranslation();

  return (
    <Styled.FeatureList>
      {usps.map(({ icon, label }) => (
        <Styled.FeatureItem key={label}>
          <Styled.FeatureIcon>
            <Icon icon={icon} size={16} strokeWidth={1.5} />
          </Styled.FeatureIcon>
          <Styled.FeatureLabel>{t(label)}</Styled.FeatureLabel>
        </Styled.FeatureItem>
      ))}
    </Styled.FeatureList>
  );
};
